import { topicGroups } from '@/mocks/homeContent';

export default function TopicWall() {
  return (
    <section id="topics" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-4 md:mb-14 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-accent-700">
              <span className="h-px w-8 bg-accent-500"></span> Topic Wall
            </span>
            <h2 className="mt-3 font-display text-3xl font-black text-foreground-950 md:text-4xl">
              热议话题墙 <span className="text-accent-600">·</span> 一贴看风向
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            顺着一个个关键词点进去，就能追到同一条线上的完整脉络。话题墙按人物、事件、综艺、大盘四条线铺开。
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {topicGroups.map((group, gi) => (
            <div
              key={group.name}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
              style={{ borderTopColor: 'transparent' }}
            >
              <div className="mb-5 flex items-center gap-3 border-b border-background-100 pb-4">
                <span
                  className={`flex h-9 w-9 items-center justify-center rounded-md text-background-50 ${
                    gi === 0
                      ? 'bg-primary-500'
                      : gi === 1
                        ? 'bg-accent-500'
                        : gi === 2
                          ? 'bg-secondary-500'
                          : 'bg-foreground-900'
                  }`}
                >
                  {gi === 0 ? <i className="ri-user-heart-line text-lg"></i> : gi === 1 ? <i className="ri-fire-line text-lg"></i> : gi === 2 ? <i className="ri-tv-2-line text-lg"></i> : <i className="ri-pie-chart-2-line text-lg"></i>}
                </span>
                <span className="flex flex-col">
                  <span className="font-display text-base font-bold text-foreground-950">{group.name}</span>
                  <span className="text-[11px] text-foreground-500">
                    {gi === 0 ? 'IDOL' : gi === 1 ? 'EVENT' : gi === 2 ? 'SHOW' : 'OVERVIEW'}
                  </span>
                </span>
              </div>

              <div className="flex flex-wrap gap-2">
                {group.tags.map((tag) => (
                  <a
                    key={tag}
                    href="#featured"
                    className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-all hover:bg-foreground-900 hover:text-background-50 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-price-tag-3-line text-[11px] text-secondary-400"></i>
                    {tag}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}